<template>
  <home-apps />
</template>

<script>
import HomeApps from '@/components/home/AnchorApps';

export default {
  name: 'HomeView',
  components: {
    HomeApps,
  },
};
</script>
